import { render, staticRenderFns } from "./trial-row.vue?vue&type=template&id=5fbc3490&"
import script from "./trial-row.vue?vue&type=script&lang=ts&"
export * from "./trial-row.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports